module.exports = __webpack_public_path__ + "static/media/mn9.b05b17a2.jpeg";